/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetInventoriesOutQuery } from '../../models/get-inventories-out-query';
import { GetInventoriesOutQueryResult } from '../../models/get-inventories-out-query-result';

export interface ApiNurseryManagerInventoryOutGetInventoriesOutPost$Params {
      body?: GetInventoriesOutQuery
}

export function apiNurseryManagerInventoryOutGetInventoriesOutPost(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerInventoryOutGetInventoriesOutPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInventoriesOutQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerInventoryOutGetInventoriesOutPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetInventoriesOutQueryResult>;
    })
  );
}

apiNurseryManagerInventoryOutGetInventoriesOutPost.PATH = '/api/NurseryManager/InventoryOut/GetInventoriesOut';
